import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { GET_PREVIOUS_POLICY_NO, SEARCH_VIX, SELECTED_MAKE_MODEL } from "@store/sat-motor/sat-motor.action";
import { UserResponse } from "@interfaces/user";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { SharedModule } from "@shared/shared.module";
import { VehicleNoValidator } from "@shared/classes/validators/vehicle-no.validator";
import { NumberRangeValidator } from "@shared/classes/validators/number-range.validator";
import { MakeModelComponent } from "@shared/components/modal/make-model/make-model.component";
import { OkMessageComponent } from "../modal/ok-message/ok-message.component";
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS } from '@aposin/ng-aquila/datefield';
import { DatePipe } from "@angular/common";
import moment from "moment";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-vehicle-view-amendment',
  standalone: true,
  imports: [SharedModule, NxMomentDateModule],
  templateUrl: './vehicle-view-amendment.component.html',
  styleUrl: './vehicle-view-amendment.component.scss',
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS },
    DatePipe
  ],
})
export class VehicleViewAmendmentComponent implements OnInit {

  @Input() isUpdateJPJScreen: boolean = false;
  @Input() isAmendDateScren: boolean = false;

  @Input() cngeNote: any;
  @Input() coverageInfo: any;

  okMessageModal?: NxModalRef<OkMessageComponent>;
  vehicleDetailForm: FormGroup;
  decimalFmt: any;
  numberFmt: any;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private readonly dialogService: NxDialogService,
  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();
    
  }

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });

    let data = this.coverageInfo.vehicleDetails;
    if (this.isUpdateJPJScreen) {
      this.vehicleDetailForm = this.fb.group({
        vehicleNo: ["", [Validators.required, this.vehicleNoValidator.bind(this)]],
        vehicleEngine: ["", [Validators.required]],
        vehicleChassis: ["", [Validators.required]],
        jpjEffectiveDate: [{ value: "", disabled: true }],
        jpjExpiryDate: [{ value: "", disabled: true }],
      });

      if (data) {
        this.vehicleDetailForm.patchValue({
          vehicleNo: data.vehicleNo,
          vehicleEngine: data.vehicleEngine,
          vehicleChassis: data.vehicleChassis,
          jpjEffectiveDate: data.jpjEffectiveDate || this.cngeNote.jpjEffectiveDate,
          jpjExpiryDate: data.jpjExpiryDate || this.cngeNote.jpjExpiryDate
        });
        //this.validateDefaultVehicleNo(data.vehicleNo);
      }
      
    }

    if (this.isAmendDateScren) {
      this.vehicleDetailForm = new FormGroup({
        vehicleNo: new FormControl('', [
          Validators.required, this.vehicleNoValidator.bind(this)
        ]),
        vehicleMakeYear: new FormControl({ value: '', disabled: true }),
        vehModelNvicDesc: new FormControl({ value: '', disabled: true }),
        vehicleEngine: new FormControl({ value: '', disabled: true }),
        vehicleChassis: new FormControl({ value: '', disabled: true }),
        jpjEffectiveDate: new FormControl('', [Validators.required]),
        jpjExpiryDate: new FormControl({ value: '', disabled: true }),
        jpjStatus: new FormControl({ value: '', disabled: true })
      });


      if (data) {
        this.vehicleDetailForm.patchValue({
          vehicleNo: data.vehicleNo,
          vehicleEngine: data.vehicleEngine,
          vehicleChassis: data.vehicleChassis,
          jpjEffectiveDate: data.jpjEffectiveDate || this.cngeNote.jpjEffectiveDate,
          jpjExpiryDate: data.jpjExpiryDate || this.cngeNote.jpjExpiryDate,
          jpjStatus: data.jpjStatus,
          vehicleMakeYear: data.vehicleMakeYear,
          vehModelNvicDesc: this.getMakeModel(data)
        });

        //this.validateDefaultVehicleNo(data.vehicleNo);
      }
    }

  }

  getMakeModel(data: any): string {
    if (data.vehModelNvic?.trim()) {
      return data.variantFullDesc
        ? `${data.piamMakeModelDesc} ${data.variantFullDesc}`
        : (data.piamMakeModelDesc  || 'N/A');
    }

    if (data.vehicleModel?.trim()) {
      return data.vehicleModelDescp || 'N/A';
    }

    return data?.makeModel || 'N/A';
  }

  validateDefaultVehicleNo(value) {
    const vehicleNo = value?.trim();

    if (!vehicleNo || vehicleNo.toUpperCase() === "NA") {
      const vehicleNoControl = this.vehicleDetailForm.get('vehicleNo');
      vehicleNoControl.setErrors({ invalidRed: true });
      this.vehicleDetailForm.get('vehicleNo').markAsTouched();
      this.vehicleDetailForm.get('vehicleNo').markAsDirty();
      vehicleNoControl.updateValueAndValidity();
      console.log(vehicleNoControl.errors);
    }
  }

  vehicleNoValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;

    const containsAlphabet = /[a-zA-Z]/.test(control.value);
    const containsNumber = /[0-9]/.test(control.value);
    const containsSpaces = /\s/.test(control.value);
    const validPattern = /^[a-zA-Z0-9-]+$/.test(control.value);

    if (control.value.trim().toUpperCase() === 'NA') {
      return { invalidRed: true };
    }

    if (!(containsAlphabet && containsNumber && !containsSpaces && validPattern)) {
      return { invalid: true };
    }
    
    return null;
  }

  onDateChange(event: any) {
    let issueDate = moment(this.cngeNote.cnoteDate, "YYYY-MM-DD");

    if (event.value) {
      const effectiveDate = moment(event.value, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (!effectiveDate.isValid()) {
        this.showOkMessage('Invalid date format. Please enter a valid date.');
        return;
      }

      if (effectiveDate.toDate() < issueDate.toDate()) {
        this.showOkMessage('Effective date cannot be earlier than issued date.');
      } else {
        const expiryDate = effectiveDate.clone().add(1, 'year').subtract(1, 'day');
        this.vehicleDetailForm.controls['jpjExpiryDate'].setValue(expiryDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"));

        this.vehicleDetailForm.patchValue({
          jpjEffectiveDate: effectiveDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        });
        const jpjEffectiveDateControl = this.vehicleDetailForm.get('jpjEffectiveDate');
        if (jpjEffectiveDateControl) {
          jpjEffectiveDateControl.setErrors(null);
          jpjEffectiveDateControl.markAsPristine();
          jpjEffectiveDateControl.markAsUntouched();
          jpjEffectiveDateControl.updateValueAndValidity();
        }
      }

    }
  }

  checkVehicleNo() {
    const vehicleNoControl = this.vehicleDetailForm.get('vehicleNo');
    if (vehicleNoControl && vehicleNoControl.hasError('invalid')) {
      this.showOkMessage('Vehicle No. is Invalid.');
    }
  }

  showOkMessage(messageData: any) {
    this.okMessageModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: messageData
      }
    });

    this.okMessageModal.afterClosed().subscribe(() => {
      if (messageData.includes('Vehicle No')) {
        this.clearVehicleNo();
      } else if (messageData.includes('Inception date') || messageData.includes('cannot be earlier than issued date')) {
        this.clearJPJDate();
      }
    });
  }

  clearJPJDate() {
    const jpjEffectiveDateControl = this.vehicleDetailForm.get('jpjEffectiveDate');
    const jpjExpiryDateControl = this.vehicleDetailForm.get('jpjExpiryDate');

    if(jpjEffectiveDateControl) {
      jpjEffectiveDateControl.reset();
    }

    if(jpjExpiryDateControl) {
      jpjExpiryDateControl.reset();
    }
  }

  clearVehicleNo() {
    const vehicleNoControl = this.vehicleDetailForm.get('vehicleNo');
    if (vehicleNoControl) {
      if (this.isUpdateJPJScreen) {
        vehicleNoControl.setValue('');
      } else {
        vehicleNoControl.setValue('NA');
      }
    }
  }

}
